import { render, staticRenderFns } from "./FormExpired.vue?vue&type=template&id=e53af96a&scoped=true&"
var script = {}
import style0 from "./FormExpired.vue?vue&type=style&index=0&id=e53af96a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53af96a",
  null
  
)

export default component.exports